import VueSlider from './vue-slider'
export { ERROR_TYPE } from './utils/control'
export default VueSlider
